import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../translates/translate"


/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)

/* CLOSE ICON */
const CloseIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
const CheckIcon = ({ size = 12 }) => (
    <Icon size={size} width={3.5}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)


/* Component Studio Filter */
class StudioFilter extends Component {

    constructor() {
        super()
        this.state = { visible: false, draft: [] }
    }

    /* Open Action — the draft starts from the applied selection */
    open = () => {
        const { studios } = this.props
        this.setState({ visible: true, draft: studios.map((item) => ({ ...item })) })
    }

    /* Close Action — every unapplied change is discarded */
    close = () => {
        this.setState({ visible: false })
    }

    /* Toggle One Studio */
    toggle = (index) => {
        const { draft } = this.state
        this.setState({ draft: draft.map((item, ind) => ind === index ? { ...item, checked: !item.checked } : item) })
    }

    /* Select / Deselect All */
    selectAll = (checked) => {
        const { draft } = this.state
        this.setState({ draft: draft.map((item) => ({ ...item, checked })) })
    }

    /* Apply Action */
    apply = () => {

        /* Fields */
        const { draft } = this.state
        const { onApply } = this.props

        /* Check Selection — at least one studio stays selected */
        if (draft.filter((item) => item.checked).length === 0) {
            return
        }

        onApply(draft)
        this.close()
    }

    render = () => {

        /* Fields */
        const { studios } = this.props
        const { visible, draft } = this.state

        const appliedCount = studios.filter((item) => item.checked).length
        const selectedCount = draft.filter((item) => item.checked).length

        return (
            <>

                <div onClick={() => this.open()} className="player-filter" title={t("filter.studios")}>
                    <img src="/images/player/filter.png" alt="Filter" />
                    {appliedCount > 0 &&
                        <div className="player-filter-count">{appliedCount}</div>
                    }
                </div>

                <Modal
                    isOpen={visible}
                    onRequestClose={() => this.close()}
                    className="studio-filter--modal"
                    overlayClassName="studio-filter--overlay"
                    closeTimeoutMS={200}
                >

                    <div className="studio-filter--header">

                        <div>
                            <h2>{t("filter.studios")}</h2>
                            <p>{t("filter.studiosSubtitle")}</p>
                        </div>

                        <div onClick={() => this.close()} className="studio-filter--close">
                            <CloseIcon />
                        </div>

                    </div>

                    <div className="studio-filter--body">

                        <div className="manager--section-head">
                            <div className="manager--section-title">
                                {t("filter.studios")}
                                <span className={`manager--counter ${selectedCount === 0 ? "empty" : ""}`}>{selectedCount}</span>
                            </div>
                            <div onClick={() => this.selectAll(selectedCount !== draft.length)} className="manager--link">
                                {selectedCount === draft.length ? t("common.clearAll") : t("common.selectAll")}
                            </div>
                        </div>

                        <div className="manager--chips">
                            {draft.map((item, index) =>
                                <div onClick={() => this.toggle(index)} className={`manager--chip green ${item.checked ? "active" : ""}`} key={`${index}`}>
                                    <div className="manager--chip-mark"><CheckIcon size={11} /></div>
                                    <div className="manager--chip-text">
                                        <div className="manager--chip-name">{item.name}</div>
                                        {item.slug ? <div className="manager--chip-slug">{item.slug}</div> : null}
                                    </div>
                                </div>
                            )}
                        </div>

                        {selectedCount === 0 &&
                            <div className="studio-filter--hint">{t("filter.studiosEmpty")}</div>
                        }

                    </div>

                    <div className="studio-filter--footer">

                        <div onClick={() => this.close()} className="studio-filter--button ghost">{t("filter.cancel")}</div>

                        <div onClick={() => this.apply()} className={`studio-filter--button primary ${selectedCount === 0 ? "disabled" : ""}`}>{t("filter.apply")}</div>

                    </div>

                </Modal>

            </>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(StudioFilter)
